import Page from '@app/components/layout/page/page';
import useSimpleDialog from '@app/hooks/use-simple-dialog';
import AdditionalCategoryEditForm from '../../components/scope-3/additional-categories/additional-category-edit-form';
import AdditionalCategoryTable from '../../components/scope-3/additional-categories/additional-category-table';
import { ScopeCategorySlug } from '../../slugs';
import { useCategory } from '../../utils';
import CCFCategoryIntroPage from '../ccf-category-intro-page';
import additionalCategoryDescriptions from './additional-category-descriptions';

interface AdditionalCategoryPageProps {
  slug: ScopeCategorySlug;
}

export default function AdditionalCategoryPage({
  slug,
}: AdditionalCategoryPageProps) {
  const category = useCategory(slug);
  const { showSimpleDialog, SimpleDialogComponent, closeSimpleDialog } =
    useSimpleDialog();

  return (
    <Page name={category?.name || 'Category'} page="subpage">
      {category.hasActivityData ? (
        <AdditionalCategoryTable activityTypeSlug={slug} />
      ) : (
        <CCFCategoryIntroPage
          categorySlug={slug}
          description={
            <div className="space-y-4">
              {additionalCategoryDescriptions[slug]}
            </div>
          }
          primaryActionProps={{
            onClick: showSimpleDialog,
          }}
        />
      )}
      {SimpleDialogComponent({
        header: 'Add data',
        content: (
          <AdditionalCategoryEditForm
            activityTypeSlug={slug}
            closeDialog={closeSimpleDialog}
          />
        ),
      })}
    </Page>
  );
}
